import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
const state = {
  vendor: {
    firstName: "",
    lastName: "",
    firmName: "",
    bankName: "",
    accountHolderName: "",
    bankAccountNumber: "",
    ifscCode: "",
    accountType: "",
    age: "",
    gender: "male",
    email: "",
    phone: "",
    address: "",
    password: "",
    isDisable: false,
    commisionPercentage: 0,
    isActive: true,
    serviceCategoryId: "",
    dutyStartTime: null,
    dutyEndTime: null
  },
  vendorList: [],
  vendorInvoiceData: {}
};

const vendor = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default vendor;
